'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stripe = (_temp = _class = function (_SvgIcon) {
  _inherits(Stripe, _SvgIcon);

  function Stripe() {
    _classCallCheck(this, Stripe);

    return _possibleConstructorReturn(this, (Stripe.__proto__ || Object.getPrototypeOf(Stripe)).apply(this, arguments));
  }

  _createClass(Stripe, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M375.6,202.3c0-24.8-12-44.4-35-44.4c-23.1,0-37.1,19.6-37.1,44.2c0,29.2,16.5,43.9,40.2,43.9c11.5,0,20.3-2.6,26.9-6.3v-19.4c-6.6,3.3-14.2,5.3-23.8,5.3c-9.4,0-17.8-3.3-18.8-14.7h47.4C375.4,209.7,375.6,204.7,375.6,202.3zM327.7,193.1c0-11,6.7-15.5,12.8-15.5c5.9,0,12.2,4.6,12.2,15.5H327.7z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M266.1,157.9c-9.5,0-15.6,4.5-19,7.6l-1.3-6h-21.3v113.1l24.2-5.1l0.1-27.5c3.5,2.5,8.6,6.1,17.2,6.1c17.4,0,33.2-14,33.2-44.7C299.1,173.2,283.1,157.9,266.1,157.9z M260.3,224.7c-5.7,0-9.1-2-11.4-4.6l-0.1-36c2.5-2.8,6-4.8,11.5-4.8c8.8,0,14.9,9.9,14.9,22.6C275.2,215,269.2,224.7,260.3,224.7z'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#6772E5',
            points: '191.1,152.2 215.5,146.9 215.5,127.2 191.1,132.4 \t'
          }),
          _react2['default'].createElement('rect', { x: '191.1', y: '159.5', fill: '#6772E5', width: '24.3', height: '84.9' }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M165,166.7l-1.6-7.2h-21v84.9h24.2v-57.5c5.7-7.5,15.4-6.1,18.4-5v-22.3C182.1,158.4,170.7,156.2,165,166.7z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M116.5,138.5l-23.7,5l-0.1,77.7c0,14.4,10.8,24.9,25.1,24.9c8,0,13.8-1.5,17-3.2v-19.7c-3.1,1.3-18.4,5.7-18.4-8.6v-34.4h18.4v-20.7h-18.4L116.5,138.5z'
          }),
          _react2['default'].createElement('path', {
            fill: '#6772E5',
            d: 'M50.9,184.2c0-3.8,3.1-5.2,8.2-5.2c7.4,0,16.7,2.2,24.1,6.2v-22.8c-8.1-3.2-16-4.5-24.1-4.5c-19.7,0-32.8,10.3-32.8,27.5c0,26.8,36.9,22.5,36.9,34c0,4.5-3.9,5.9-9.3,5.9c-8.1,0-18.3-3.3-26.5-7.8v23.1c9,3.9,18.1,5.5,26.5,5.5c20.2,0,34-10,34-27.4C87.9,189.9,50.9,195.1,50.9,184.2z'
          })
        );
      }

      return render;
    }()
  }]);

  return Stripe;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Stripe;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Stripe.js
// module id = 1407
// module chunks = 32